module.exports = __webpack_public_path__ + "img/ramadan-cover.e8194216.jpg";